import React from 'react';
const links = ['Conditions Générales', 'Politique de Confidentialité', 'Contact'];
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink-950 px-4 pb-28 pt-12" data-id="element-108" data-mp="206rfr8n93coj">
      <div className="mx-auto max-w-2xl text-center" data-id="element-109" data-mp="2f53avauz6ddl">
        <p className="font-display text-2xl font-bold uppercase leading-none text-white" data-id="element-110" data-mp="2f2h5nhvk49yj">
          Système <span className="text-arc-400" data-id="element-111" data-mp="2a3w6lls1jwbo">Maître</span> de Soudage™
        </p>
        <nav aria-label="Liens légaux" className="mt-5" data-id="element-112" data-mp="1mgfo1aukvfxx">
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-113" data-mp="1hhum96zogo7d">
            {links.map(l => <li key={l} data-id="element-114" data-mp="1w6r1pp42d3i0">
                <a href="#" className="text-xs font-medium text-white/50 transition-colors duration-150 ease-out hover:text-white" data-id="element-115" data-mp="1w825hoxieb94">
                  {l}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mt-6 text-[11px] leading-relaxed text-white/35" data-id="element-116" data-mp="yqbjn19kfc5v">
          © 2026 Système Maître de Soudage™ — Tous droits réservés.
        </p>
      </div>
    </footer>;
}